import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { default as bsMddSharedConfig } from 'Components/Worksheets/MaximumDryDensityWorksheet/Bs/Shared/Config';
import { default as qestIds } from 'Components/Worksheets/QestIds';

const getConfig = (prefix: string) => mergeConfig(bsMddSharedConfig(prefix));

export default {
  [qestIds.maximumDryDensity.BS_1377_2_Clause_11_3_11_4.rev2022]: getConfig,
};
